<template>
  <div style="min-height: 200px;">
    <div v-if="employee">
      <b-form-group label="Código">
        <b-form-input v-model="employee.codigo" disabled></b-form-input>
      </b-form-group>
      <b-form-group label="Nome" class="mt-3">
        <b-form-input v-model="employee.nome" disabled></b-form-input>
      </b-form-group>
      <!-- ZPG-15: com Encerramento de Diversos ativo o back recusa o desligamento; a tela so espelha. -->
      <b-form-checkbox class="mt-3" switch v-model="employee.emProcessoDemissao" :disabled="!!employeeOrig.emCancelamentoDiversos">Em Processo de Desligamento</b-form-checkbox>
      <b-button variant="third" class="mt-5" @click="onSave" v-if="employee.emProcessoDemissao !== employeeOrig.emProcessoDemissao">Salvar</b-button>
      <div class="mt-5" v-if="employee.emProcessoDemissao">
        <p><strong>ATENÇÃO</strong></p>
        <p>Será necessário solicitar ao funcionário o lançamento e o envio de todas as despesas em mãos. Após o próximo envio pelo Z-Pag, o usuário será inativado, e não será mais possível enviar outras despesas.</p>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import { loading } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import { clone } from 'lodash'

export default {
  name: 'DetailsCollaborator',
  mixins: [CompanyMixin],
  data () {
    return {
      formSearch: {},
      employee: null,
      employeeOrig: null
    }
  },
  methods: {
    onLoad () {
      loading.push()
      EmployeeRepository.GetById(this.formSearch.FuncionarioID)
        .then(response => {
          if (response.data.code > 0) {
            this.employeeOrig = response.data.data
            this.employee = clone(this.employeeOrig)
            this.formSearch.CompanyID = this.company.id
          }
        })
        .finally(() => loading.close())
    },
    onSave () {
      loading.push()
      EmployeeRepository.Update(this.employee)
        .then(response => {
          if (response.data.code > 0) {
            this.employeeOrig = response.data.data
          }
        })
        .finally(() => loading.close())
    }
  }
}
</script>

<style scoped>
p {
  font-size: 1.5rem;
  color: red;
  line-height: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/detailscollaborator/detailscollaborator.vue